<!-- 
	This is the cover sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
    <div id="container">
        <a-row type="flex" align="middle">
            <a-col
                :span="24"
                :md="24"
                :lg="{ span: 20, offset: 2 }"
                :xl="{ span: 12, offset: 6 }"
                align="center"
            >
                <img id="logo-ugm" src="siakri/images/logo-ugm.png"/>
            </a-col>
        </a-row>

        <a-row type="flex" align="middle">
            <a-col
                :span="24"
                :md="24"
                :lg="{ span: 20, offset: 2 }"
                :xl="{ span: 12, offset: 6 }"
            >
                <h4 id="title-app-name" class="text-dark">{{ appName }}</h4>
                <h4 id="title-rsgm" class="text-dark">{{ appRsgm }}</h4>
            </a-col>
        </a-row>

        <a-row type="flex" :gutter="[24, 24]" align="middle" class="row-main my-0">
            <!-- Sign In Form Column -->
            <a-col
                :span="24"
                :sm="{ span: 16, offset: 4 }"
                :md="{ span: 14, offset: 5 }"
                :lg="{ span: 12, offset: 6 }"
                :xl="{ span: 8, offset: 8 }"
                class="col-form"
            >
                <h3 class="text-dark mb-15">Login</h3>

                <!-- Sign In Form -->
                <a-form
                    id="components-form-demo-normal-signup"
                    :form="form"
                    class="signup-form"
                    @submit="handleSubmit"
                    :hideRequiredMark="true"
                >
                    <a-form-item class="mb-10" label="Role" :colon="false">
                        <a-select
                            v-model="loginData.role"
                            v-decorator="[
                'gender',
                {
                  rules: [
                    { required: true, message: 'Please select role!' },
                  ],
                },
              ]"
                            placeholder="Pilih role"
                        >
<!--                            <a-select-option value="admin"> Admin</a-select-option>-->
                            <a-select-option value="koas"> Koas</a-select-option>
                            <a-select-option value="dokter"> DPJP</a-select-option>
                            <a-select-option value="pj_bahan"> PJ Bahan</a-select-option>
                            <a-select-option value="pendidikan"> Pendidikan</a-select-option>
                            <a-select-option value="admin"> Admin</a-select-option>
<!--                            <a-select-option value="perawat_bangsal">-->
<!--                                Perawat Bangsal-->
<!--                            </a-select-option>-->
                        </a-select>
                    </a-form-item>
                    <a-form-item class="mb-10" label="Username" :colon="false">
                        <a-input
                            v-model="loginData.username"
                            v-decorator="[
                'Username',
                {
                  rules: [
                    { required: true, message: 'Mohon masukan username' },
                  ],
                },
              ]"
                            placeholder="Username"
                        />
                    </a-form-item>
                    <a-form-item class="mb-5" label="Password" :colon="false">
                        <a-input
                            v-model="loginData.password"
                            v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'Please input your password!' },
                  ],
                },
              ]"
                            type="password"
                            placeholder="Password"
                        />
                    </a-form-item>
                    <a-form-item>
                        <a-button
                            type="primary"
                            block
                            html-type="submit"
                            class="signup-form-button"
                            style="margin-top: 10px"
                            :disabled="!captchaVerified"
                        >
                            MASUK
                        </a-button>
                    </a-form-item>

<!--                    <a-form-item>-->
<!--                        <vue-recaptcha-->
<!--                            id="captca"-->
<!--                            style="text-align: center"-->
<!--                            ref="recaptcha" sitekey="6Le36VghAAAAAHFRRqm2bIYznFMMKDiCdFQKItiY"-->
<!--                            :loadRecaptchaScript="true"-->
<!--                            @verify="verify"-->
<!--                        ></vue-recaptcha>-->
<!--                    </a-form-item>-->
                </a-form>
                <!-- / Sign In Form -->
            </a-col>
            <!-- / Sign In Form Column -->

            <a-col
                :span="24"
                :sm="{ span: 16, offset: 4 }"
                :md="{ span: 14, offset: 5 }"
                :lg="{ span: 12, offset: 6 }"
                :xl="{ span: 8, offset: 8 }"
                class="col-form"
            >

            </a-col>
        </a-row>
    </div>
</template>

<script>
import AuthApi from "../../repository/api/AuthApi";
import {APP_NAME, APP_RSGM} from "../../utils/Config";
import VueRecaptcha from 'vue-recaptcha';
import store from "../../store";

export default {
    components: { VueRecaptcha },

    data() {
        return {
            // Sign up form object.
            form: this.$form.createForm(this, {name: "signup_cover"}),
            loginData: {
                role: "",
                username: "",
                password: "",
            },

            // captchaVerified: false,
            captchaVerified: true,
        };
    },

    mounted() {
        // if (this.$store.getters['auth/isLogin']) {
        //     this.$router.push("/dashboards");
        // }
    },

    methods: {
        // Handles input validation after submission.
        async handleSubmit(e) {
            e.preventDefault();

            if (!this.captchaVerified) {
                this.$swal({
                    type: "error",
                    icon: "error",
                    title: "ERROR",
                    text: "Isi captcha",
                });

                return
            }

            await this.form.validateFields(async (err, values) => {
                if (!err) {
                    AuthApi.login(this.loginData)
                        .then(async (response) => {
                            if (this.loginData.role === 'koas') {
                                await this.$swal({
                                    icon: "success",
                                    title: "Berhasil Login",
                                });

                                const data = {
                                    token: response.token,
                                    user: response,
                                    role: response.role,
                                }

                                await this.$store.dispatch('auth/login', data)
                                await this.$router.push("/dashboards");
                            }
                            else {
                                await this.$swal({
                                    icon: "success",
                                    title: "Berhasil Login",
                                });

                                response.user = {
                                    'name': response.name
                                }

                                await this.$store.dispatch('auth/login', response)
                                await this.$router.push("/dashboards");
                            }
                        })
                        .catch((e) => {
                            this.$swal({
                                icon: e.severity || "error",
                                title: (e.severity || "error").toUpperCase(),
                                text: e.message,
                            });
                        })
                }
                this.$loading = false;
            });
        },

        onEvent() {
            this.$refs.recaptcha.execute();
        },

        verify(e) {
            console.log("VERIF")
            console.log(e)

            this.captchaVerified = true
        }
    },

    computed: {
        appName() {
            return APP_NAME
        },

        appRsgm() {
            return APP_RSGM
        }
    },
};
</script>

<style scoped lang="scss">

#container {
    padding-top: 5vh;
}

#title-app-name {
    margin-bottom: 0;
    margin-top: 10px;
    font-weight: normal;
}

#title-rsgm {
    margin-bottom: 0;
}

#logo-ugm {
    width: 90px;
}

h3, h4 {
    text-align: center;
}

h3 {
    font-size: 24px;
}

h4 {
    font-size: 18px;
}

::v-deep #captca div {
    margin: 0 auto !important;
    width: 304px !important;
}

</style>